/**
 * مطابقة أنماط الصفحات — ملفّ نقيّ بلا أيّ اعتماد على كتالوج صفحات الأدمن،
 * كي لا تتسرّب قوائم الأدمن إلى حزمة الصفحات العامّة (LCP/JS budget).
 *
 * يدعم:
 *   - "all" → دائماً يُطابق
 *   - "/path" → مطابقة تامّة للـ pathname
 *   - "/path/*" → مطابقة prefix للـ pathname
 *   - "/path?key=value" → pathname يُطابق + query يحوي key=value
 *   - "/path?key=*" → pathname يُطابق + query يحوي key بأيّ قيمة
 */
export function matchPagePattern(
  pathname: string,
  search: string,
  pattern: string,
): boolean {
  if (pattern === "all") return true;

  const [pathPart, queryPart] = pattern.split("?");

  let pathOk = false;
  if (pathPart === pathname) pathOk = true;
  else if (pathPart.endsWith("/*")) {
    const prefix = pathPart.slice(0, -2);
    pathOk = pathname === prefix || pathname.startsWith(prefix + "/");
  }
  if (!pathOk) return false;

  if (!queryPart) return true;

  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const [key, expected] = queryPart.split("=");
  if (!params.has(key)) return false;
  if (expected === "*" || expected === undefined) return true;
  return params.get(key) === expected;
}
